import breadcrumbSlice from "./breadcrumbSlice";
import ClaimSlice from "./claimSlice";
import HelpPanelReducer from "./HelpPanelSlice";
import cmsLoadingSlice from "./cmsLoadingSlice";
import userSliceReducer from "./userSlice";
import featureFlagsReducer from "./featureFlagsSlice";

const reducers = {
  ClaimSlice: ClaimSlice.reducer,
  HelpPanelSlice: HelpPanelReducer,
  UserSlice: userSliceReducer,
  FeatureFlagsSlice: featureFlagsReducer,
  BreadcrumbSlice: breadcrumbSlice,
  CmsLoading: cmsLoadingSlice,
};

export default reducers;
